import { ReactElement } from 'react';
import { sepFormat } from 'utilities';
import { header, oddRow } from 'styles/style.css';
import { RemoveButton } from 'components';
import type { ApplicationType, AppliedLink } from 'modules/applicator/types';
import { InvoiceWidget } from 'modules/invoicing/common/InvoiceWidget';

type AppliedListProps = {
  items: AppliedLink[];
  applicationType: ApplicationType;
  actionHandler?: (item: AppliedLink) => void;
};

export function AppliedList({ items, applicationType, actionHandler }: AppliedListProps): ReactElement {
  return (
    <table className="form-table table" data-testid="applied">
      <thead>
        <tr className={header.dark}>
          <th>Applied to invoice</th>
          <th className="text-right">Total amount</th>
          <th className="text-right">Applied amount</th>
          <th className="tools"></th>
        </tr>
      </thead>
      <tbody>
        {items.map((item, idx) => {
          const { destination, amount } = item;

          const totalAmount = destination[applicationType === 'advance' ? 'total' : 'sub_total'];

          return (
            <tr key={destination.id} className={idx % 2 === 0 ? oddRow : undefined}>
              <td>
                <InvoiceWidget invoice={destination} link />
              </td>
              <td className="text-right align-middle">{sepFormat(totalAmount)}</td>
              <td className="text-right align-middle">{sepFormat(amount)}</td>
              <td className="tools align-middle">
                {actionHandler && (
                  <RemoveButton testId={`applied-action-${destination.id}`} onClick={() => actionHandler(item)} />
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
